import { createSlice } from '@reduxjs/toolkit';
import {
  ContactSortTypes,
  ContactStatus,
  IContactParams,
} from 'shared';

export const initialState: IContactParams = {
  page: 1,
  limit: 50,
  searchStr: ``,
  groupId: null,
  externalAggregateName: null,
  status: ContactStatus.ACTIVE, // Only show active contacts for now
  tags: [],
  sortBy: ContactSortTypes.ALPHABETICAL_ASC,
  frozen: null,
  name: null,
};

const contactParamsSlice = createSlice({
  name: `contactParams`,
  initialState,
  reducers: {
    setParams(state, action) {
      Object.assign(state, action.payload);
    },
  },
});

export const { setParams } = contactParamsSlice.actions;

export const contactParamsReducer = contactParamsSlice.reducer;
